// extracted by mini-css-extract-plugin
export default {"myPageUpper":"TopOverlay_myPageUpper__aRhxW","logoOverlay":"TopOverlay_logoOverlay__XMlCw","editIcon":"TopOverlay_editIcon__zNU09"};